import config from '@config';

type FetchType = typeof fetch;

/**
 * Smart fetch utility that delegates to the appropriate fetch method
 * based on WAF configuration and presence of global AwsWafIntegration.
 *
 * @param input - The URL or Request to fetch
 * @param init - Optional fetch init config
 * @returns A Promise that resolves to a Response
 */
export const smartFetch: FetchType = (input, init?) => {
	const useWaf =
		config.wafEnabled &&
		typeof window !== 'undefined' &&
		typeof (window as any).AwsWafIntegration?.fetch === 'function';

	const fetchFn: FetchType = useWaf
		? (window as any).AwsWafIntegration.fetch
		: fetch;

	return fetchFn(input, init);
};
